import request from "./request";
/**
 * 用户绑定查询列表
 * @param userName 用户名
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getBindUserPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataAuthorizationPlayer/getBindUserPage", {
    params: { ...defaultParams, ...params },
  });
}
